// The in-progress sheet used to be autosaved to IndexedDB and restored on the next visit. That caused more
// confusion than it helped (an old sheet kept coming back instead of the admin's current defaults), so it is
// gone. What visitors still have stored from then is deleted once, so it does not linger in their browser.

const DB_NAME = 'samolepky-draft';

export function deleteLegacyDraft(): void {
  try {
    indexedDB.deleteDatabase(DB_NAME);
  } catch (e) {
    console.error('[Draft] Delete failed:', e);
  }
}
